module.exports = __webpack_public_path__ + "static/media/grandma-attack-card.39e5fccb.wav";